module.exports = __webpack_public_path__ + "static/media/approved-blue.588b1395.svg";